<template>
  <div id="func-11">
    <FuncionalidadeHeader
      :titulo="funcParametros.dashboard.nome"
      :voltar="!isWidget"
    />
    <template v-if="isWidget">
      <div style="padding: 20px">
        <el-row>
          <date-blocks-vertical
            :show-pagination="false"
            :show-more-button="true"
          >
            <template v-slot:actions="item">
              <acoes-coparticipacao
                :row="dataExtrato(item.selected)"
              />
            </template>
          </date-blocks-vertical>
        </el-row>
      </div>
    </template>
    <template v-else>
      <div style="padding: 0 20px">
      <el-row>
        <el-col :span="15">

          <el-row style="margin-bottom: 25px">
            <div style="padding-top: 15px">
              <el-row class="func-11-item" :style="`border-radius: 10px; ${estiloLinha};display: flex;align-items: center;`">
                <el-col :span="8" class="text-right">
                  <el-button
                    type="text"
                    :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}!important;`"
                    @click="selecionaMes('prev')"
                  >
                    <i class="el-icon-arrow-left"></i>
                  </el-button>
                </el-col>
                <el-col :span="8" class="text-center">
                  <h2
                    class="func-11-title-header"
                    :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`"
                  >
                    {{ mesSelecionado.label }}  {{ mesSelecionado.year }}
                  </h2>
                  <h3
                    :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}; font-size:32px; margin-top:2px;`"
                    v-html="parseValor(mesSelecionado.valorTotalCoparticipacao)"
                    v-if="mesSelecionado.valorTotalCoparticipacao"
                  >
                  </h3>
                </el-col>
                <el-col :span="8">
                  <el-button
                    type="text"
                    :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}!important;`"
                    :disabled="(!permiteNavegarProximosPeriodos && mesSelecionado.value == mesAtual) ? true : false"
                    @click="selecionaMes('next')"
                  >
                    <i class="el-icon-arrow-right" style="font-size: 16px; font-weight: bold;"></i>
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </el-row>
          <doughnut ref="donut" :maximo-de-fatias="3" :graficoData="data"></doughnut>
          <el-row v-if="extratos && extratos.length > 0">
            <ul class="func-listagens">
              <li
                v-for="(extrato, index) in extratos"
                :key="index"
                :name="index"
                class="func-11-li"
              >
                <div @click="showDetalhe(funcParametros, mesSelecionado, extrato)" style="cursor:pointer" v-if="visualizaDetalheGrupoFamiliar">
                  <el-row class="func-11-item">
                    <el-col :span="18">
                      <h2 class="func-11-title">{{ extrato.descricaoContrato }}</h2>
                      <span class="sub">{{ textoVinculoContrato }}: {{ extrato.idContrato }}</span>
                    </el-col>
                    <el-col :span="4" class="text-right">
                      <h2
                        class="func-11-title"
                        style="margin-right: 16px"
                        v-html="parseValor(extrato.valorTotalPorContrato)">
                      </h2>
                    </el-col>
                    <el-col :span="2" class="text-center" >
                      <i class="el-icon-arrow-right" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}; margin-left:8px`"></i>
                    </el-col>
                  </el-row>
                </div>
                <div v-else>
                  <el-row class="func-11-item" >
                    <el-col :span="18">
                      <h2 class="func-11-title">{{ extrato.descricaoContrato }}</h2>
                      <span class="sub">{{ textoVinculoContrato }}: {{ extrato.idContrato }}</span>
                    </el-col>
                    <el-col :span="4" class="text-right">
                      <h2
                        class="func-11-title"
                        style="margin-right: 16px"
                        v-html="parseValor(extrato.valorTotalPorContrato)">
                      </h2>
                    </el-col>
                  </el-row>
                </div>

                <div>
                  <ul
                    class="func-listagens"
                    style="padding: 0px 20px 0 12px"
                  >
                    <template v-for="(procedimento, i) in extrato.procedimentos">
                      <li :key="i" :name="i" class="func-11-item"
                      :style="`margin-bottom: 10px; border-radius: 10px; background: ${corPrimariaAplicacao}0d !important;cursor:pointer;`"
                          v-if="visualizaDetalheGrupoFamiliar || procedimento.chaveUnica===user.chaveUnica"
                          @click="showDetalhe(funcParametros, mesSelecionado, procedimento)"
                      >
                      <el-row>
                        <el-col :span="18">
                          <h2 class="func-11-title">{{ procedimento.nomeBeneficiario}}</h2>
                          <span class="sub">{{ procedimento.chaveUnica }}</span>  <span class="sub" style="margin-left:25px">{{ procedimento.tipoUsuario }} </span><br/>
                        </el-col>
                        <el-col :span="4" class="text-right">
                          <h2 class="func-11-title" v-html="parseValor(procedimento.valorTotalPorBeneficiario)"></h2>
                        </el-col>
                        <el-col :span="2" class="text-right">
                          <i class="el-icon-arrow-right" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`"></i>
                        </el-col>
                      </el-row>
                    </li>
                      <li :key="i" :name="i" class="func-11-item"
                          :style="`margin-bottom: 10px; border-radius: 10px; background: ${corPrimariaAplicacao}0d !important;`"
                          v-else
                      >
                        <el-row>
                          <el-col :span="18">
                            <h2 class="func-11-title">{{ procedimento.nomeBeneficiario}}</h2>
                            <span class="sub">{{ procedimento.chaveUnica }}</span>  <span class="sub" style="margin-left:25px">{{ procedimento.tipoUsuario }} </span><br/>
                          </el-col>
                          <el-col :span="4" class="text-right">
                            <h2 class="func-11-title" v-html="parseValor(procedimento.valorTotalPorBeneficiario)"></h2>
                          </el-col>
                          <el-col :span="2" class="text-right">
                          </el-col>
                        </el-row>
                      </li>
                    </template>
                  </ul>
                </div>
              </li>
            </ul>
          </el-row>

          <el-row v-else-if="extratos && extratos.length === 0">
            <ErrorVazio
              :titulo="errorVazio.titulo"
              :texto="errorVazio.texto"
              :showBtn="false"/>
          </el-row>

          <el-row v-if="!extratos && reqError">
            <ErrorCarregar />
          </el-row>

          <el-row class="func-11-item" v-if="exibeObservacao">
            <div class="sub" v-if="refreshData && data.observacao">
              <p><b>Observações:</b> {{ data.observacao }} </p>
            </div>
          </el-row>
        </el-col>

        <el-col :span="9">

          <div class="line"></div>
          <div style="margin: 0 15px 0 25px">
            <el-row class="func-11-item">
              <el-col :span="24">
                <h2 class="func-11-title-header">Histórico de Coparticipação</h2>
              </el-col>
            </el-row>

            <el-row class="func-11-item" style="padding-top: 5px!important">
              <ul class="func-listagens">
                <li
                  v-for="(item, index) in mesesHistorico"
                  :key="index"
                  :name="index"
                  class=""
                  :style="`margin-bottom: 10px; border-radius: 6px; ${estiloLinha}`"
                  @click="getList(item.mesDate)"
                >
                  <el-row class="func-11-item" style="margin-bottom: 0; cursor:pointer;">
                    <el-col :span="4">
                      <h2 class="func-11-title">{{ item.ano }}</h2>
                    </el-col>
                    <el-col :span="18">
                      <h2 class="func-11-title">{{ item.mes }}</h2>
                    </el-col>
                    <el-col :span="2" class="text-right">
                      <i class="el-icon-arrow-right" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}; font-size: 16px; font-weight: bold;`"></i>
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </el-row>
            <el-row class="func-11-item">
              <MenuVertical :columns="actionsList"/>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    </template>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ErrorCarregar from '@/components/Error/ErrorCarregar'
import ErrorVazio from '@/components/Error/ErrorVazio'
import Doughnut from '@/components/charts/Doughnut'
import AcoesCoparticipacao from '@/views/11/AcoesCoparticipacao'
import DateBlocksVertical from '@/components/Listagem/dateBlocksVertical'
import MenuVertical from '@/components/MenuVertical/MenuVertical.vue'

export default {
  name: 'Func11ExtratoCoparticipacao',
  components: {
    MenuVertical,
    DateBlocksVertical,
    AcoesCoparticipacao,
    FuncionalidadeHeader,
    ErrorCarregar,
    ErrorVazio,
    Doughnut
  },
  data () {
    return {
      data: { valorTotalExtrato: null },
      dateRange: [],
      reqError: true,
      refreshData: true,
      customLabel: false,
      showDialog: false,
      procedimentoDetalhe: null,
      errorVazio: {
        titulo: 'Nenhuma coparticipação encontrada!',
        texto: 'Não localizamos nenhuma utilização no periodo informado.'
      },
      extratos: [],
      collapseds: [],
      mesesHistorico: [],
      columns: [
        { field: 'nomeBeneficiario' },
        { field: 'valorServico', html: this.parseValor }
      ],
      filter: {
        dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
        dataFinal: moment().endOf('month').format('YYYY-MM-DD')
      },
      mesAtual: moment().format('YYYY-MM-DD'),
      mesSelecionado: {}
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'aplicacao']),
    ...mapGetters('Login', ['user']),
    ...mapGetters('SetupApp', ['estilo', 'isWidget', 'textoVinculoContrato']),
    corPrimariaAplicacao () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    funcParametros () {
      return this.funcionalidade.parametros
    },
    tipoAgrupamentoRegistros () {
      return this.funcionalidade.parametros.tipoAgrupamentoRegistros
    },
    visualizaDetalheGrupoFamiliar () {
      return this.funcionalidade.parametros.visualizaDetalheGrupoFamiliar
    },
    permiteNavegarProximosPeriodos () {
      return this.funcionalidade.parametros.permiteNavegarProximosPeriodos
    },
    exibeObservacao () {
      return this.visualizaDetalheGrupoFamiliar || false
    },
    estiloLinha () {
      return `background: ${this.corPrimariaAplicacao}0d !important;cursor:pointer; `
    },
    exibeExtratoPdf () {
      return this.funcionalidade.parametros.exibeExtratoPDF
    },
    actionsList () {
      return [
        {
          title: 'Salvar',
          action: this.loadPdf,
          show: this.exibeExtratoPdf
        }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    parseValor: function (valor) {
      return `R$ ${Math.floor(valor)},<span>${(valor - Math.floor(valor)).toFixed(2).split('.')[1]}</span>`
    },
    parseDate: function (value) {
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    async init () {
      if (localStorage.getItem('dadosMesAtual')) {
        const storage = JSON.parse(localStorage.getItem('dadosMesAtual'))
        this.mesSelecionado = storage.mesSelecionado
        this.data = storage.data

        this.agruparPorContrato()
        await this.$refs.donut.fillData(this.data.extrato)
        localStorage.removeItem('dadosMesAtual')
      } else {
        this.mesSelecionado.value = moment().format('YYYY-MM-DD')
        let mes = moment().locale('pt-br').format('MMMM').toString()
        this.mesSelecionado.label = mes[0].toUpperCase() + mes.slice(1)
        this.mesSelecionado.year = moment(this.mesSelecionado.value).format('YYYY')
        if (!this.isWidget) {
          await this.getList()
        }
      }
      localStorage.removeItem('params')

      if (!this.isWidget) {
        this.getMesesHistorico()
      }
    },
    agruparPorContrato () {
      const result = this.data.extrato.reduce(function (r, a) {
        r[a.idContrato] = r[a.idContrato] || []
        r[a.idContrato].push(a)
        return r
      }, Object.create(null))

      this.mesSelecionado.valorTotalCoparticipacao = 0

      for (const key in result) {
        const mappedData = { ...result[key] }

        const extrato = {
          descricaoContrato: mappedData[0].descricaoContrato,
          idContrato: mappedData[0].idContrato,
          valorTotalPorContrato: 0,
          procedimentos: []
        }

        const procedimentos = Object.keys(mappedData).map(key => mappedData[key])

        // organizar procedimentos por beneficiario
        const result2 = procedimentos.reduce(function (r, a) {
          r[a.chaveUnica] = r[a.chaveUnica] || []
          r[a.chaveUnica].push(a)
          return r
        }, Object.create(null))

        for (const key in result2) {
          const mappedData2 = { ...result2[key] }

          const extratoBeneficiario = {
            nomeBeneficiario: mappedData2[0].nomeBeneficiario,
            idTipoUsuario: mappedData2[0].idTipoUsuario,
            chaveUnica: mappedData2[0].chaveUnica,
            idContrato: mappedData2[0].idContrato,
            descricaoContrato: mappedData2[0].descricaoContrato,
            valorTotalPorBeneficiario: 0,
            procedimentos: Object.keys(mappedData2).map(key => mappedData2[key])
          }

          switch (extratoBeneficiario.idTipoUsuario) {
            case 'T':
              extratoBeneficiario.tipoUsuario = 'Titular'
              break
            case 'D':
              extratoBeneficiario.tipoUsuario = 'Dependente'
              break
            case 'A':
              extratoBeneficiario.tipoUsuario = 'Agregado'
              break
          }

          extratoBeneficiario.procedimentos.map(proc => {
            let valorServico = proc.valorCoparticipacao * proc.quantidade
            extratoBeneficiario.valorTotalPorBeneficiario += valorServico
          })
          extrato.procedimentos.push(extratoBeneficiario)
        }

        extrato.procedimentos.map(proc => {
          extrato.valorTotalPorContrato += proc.valorTotalPorBeneficiario
        })

        this.mesSelecionado.valorTotalCoparticipacao += extrato.valorTotalPorContrato
        this.extratos.push(extrato)
      }
    },
    async getList (filtro, custom = null) {
      this.refreshData = false
      this.customLabel = false

      if (filtro && custom) {
        this.customLabel = true
        this.filter.dataInicial = moment(filtro[0]).format('YYYY-MM-DD')
        this.filter.dataFinal = moment(filtro[1]).format('YYYY-MM-DD')

        let dataInicialLabel = moment(filtro[0]).format('DD/MM/YYYY')
        let dataFinalLabel = moment(filtro[1]).format('DD/MM/YYYY')

        this.mesSelecionado.label = `${dataInicialLabel} a ${dataFinalLabel}`
        this.mesSelecionado.value = filtro[0] || this.mesAtual
      } else {
        filtro = filtro || this.mesAtual
        this.filter.dataInicial = moment(filtro).startOf('month').format('YYYY-MM-DD')
        this.filter.dataFinal = moment(filtro).endOf('month').format('YYYY-MM-DD')
        this.dateRange = []

        this.mesSelecionado.label = this.formatMounth(filtro)
        this.mesSelecionado.value = filtro
      }
      this.mesSelecionado.year = this.getYear(this.mesSelecionado.value)

      const lista = await this.apiFuncionalidade.extrato({
        payload: this.filter,
        loading: true,
        handlerErrorIgnore: [404]
      })

      this.extratos = []
      this.data.valorTotalExtrato = 0
      this.refreshData = true
      if (lista.status) {
        this.reqError = false
        this.data = lista.data
        this.data.valorTotalExtrato = 0

        this.agruparPorContrato(this.data)

        await this.$refs.donut.fillData(this.data.extrato)
      } else {
        this.data.dataInicioPeriodoApuracao = moment(this.mesSelecionado.value).startOf('month').format('YYYY-MM-DD')
        this.data.dataFimPeriodoApuracao = moment(this.mesSelecionado.value).endOf('month').format('YYYY-MM-DD')
        this.reqError = true
      }
    },
    async selecionaMes (filtro) {
      let mesSelecionado = ''
      if (filtro === 'prev') {
        mesSelecionado = moment(this.mesSelecionado.value).subtract(1, 'months').format('YYYY-MM-DD')
      } else if (filtro === 'next') {
        mesSelecionado = moment(this.mesSelecionado.value).add(1, 'months').format('YYYY-MM-DD')
      }

      this.mesSelecionado.label = this.formatMounth(mesSelecionado)
      this.mesSelecionado.value = mesSelecionado
      this.mesSelecionado.year = this.getYear(mesSelecionado)

      await this.getList(mesSelecionado)
    },
    getYear (date) {
      return moment(date).format('YYYY')
    },
    formatMounth (date) {
      let mounth = moment(date).locale('pt-br').format('MMMM').toString()
      return mounth[0].toUpperCase() + mounth.slice(1)
    },
    getMesesHistorico () {
      let oldMounth = moment().format('YYYY-MM-DD')

      for (let i = 0; i < 7; i++) {
        this.mesesHistorico.push({
          ano: this.getYear(oldMounth),
          mes: this.formatMounth(oldMounth),
          mesDate: oldMounth
        })
        oldMounth = moment(oldMounth).subtract(1, 'months').format('YYYY-MM-DD')
      }
    },
    showDetalhe (parametros, mes, extrato) {
      if (this.visualizaDetalheGrupoFamiliar) {
        const params = { parametros, mes, extrato, corPrimariaAplicacao: this.corPrimariaAplicacao }
        localStorage.setItem('params', JSON.stringify(params))
        localStorage.setItem('dadosMesAtual', JSON.stringify({ data: this.data, mesSelecionado: this.mesSelecionado }))

        this.$router.push({ path: '/11/detalhe' })
      } else {
        if (extrato.chaveUnica === this.user.chaveUnica) {
          const params = { parametros, mes, extrato, corPrimariaAplicacao: this.corPrimariaAplicacao }
          localStorage.setItem('params', JSON.stringify(params))
          localStorage.setItem('dadosMesAtual', JSON.stringify({
            data: this.data,
            mesSelecionado: this.mesSelecionado
          }))

          this.$router.push({ path: '/11/detalhe' })
        }
      }
    },
    dataExtrato (item) {
      return {
        'chaveUnica': this.user.chaveUnica,
        'dataInicial': moment(item.mesDate).startOf('month').format('YYYY-MM-DD'),
        'dataFinal': moment(item.mesDate).endOf('month').format('YYYY-MM-DD'),
        'descricao': `Extrato Mês ${item.mes} ${item.ano}`
      }
    },
    async loadPdf () {
      const response = await this.apiFuncionalidade.extratoPdf({
        payload: {
          dataInicial: this.filter.dataInicial,
          dataFinal: this.filter.dataFinal
        },
        loading: true,
        handlerErrorIgnore: [404]
      })
      if (response.statusCode === 200 && response.data.base64) {
        window.open(this.baseToUrl(response.data.base64), '_blank')
      }
      if (response.statusCode === 200 && response.data.url) {
        window.open(response.data.url, '_blank')
      }
      if (response.statusCode !== 200 || (!response.data.url && !response.data.base64)) {
        this.$message.error('Erro ao gerar PDF')
      }
    },
    baseToUrl (base) {
      const binaryPDF = window.atob(base)
      const byteArray = new Uint8Array(binaryPDF.length)
      for (let i = 0; i < binaryPDF.length; i++) {
        byteArray[i] = binaryPDF.charCodeAt(i)
      }
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      return URL.createObjectURL(blob)
    }
  }
}
</script>
<style scoped>
.line {
  height: 100%;
  border-right: 1px solid #EEEEEE;
  float: left;
  position: absolute;
  margin-top: 0px;
  margin-left: 20px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  opacity: 1;
}
</style>
